import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { StyledLabel } from "../../../common/components/InputLabel";

const MaintainImproveInput = ({ register, error, helperText, name, label }) => {
  const labelId = `${name}-label`;
  const items = ["Maintain", "Improve"];

  return (
    <>
      <Grid item xs={3} sx={{marginTop: 1}}>
        <StyledLabel error={error} id={labelId}>
          {label}
        </StyledLabel>
        <FormHelperText error={error}>{helperText}</FormHelperText>
      </Grid>
      <Grid item xs={9}>
        <Box>
          <FormControl>
            <RadioGroup aria-labelledby={labelId} name={name}>
              {items.map((item) => (
                <FormControlLabel
                  key={item}
                  value={item}
                  control={<Radio {...register(name)} />}
                  label={item}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Box>
      </Grid>
    </>
  );
};

export default MaintainImproveInput;
